import { Navigate, useLocation, useParams } from "react-router";

/** The pre-family Studio URL `/mapping/:entityId/:version` meant the sales profile; keep old links alive. */
export function LegacyMappingRedirect() {
  const { entityId, version } = useParams();
  const location = useLocation();
  return <Navigate replace to={`/mapping/${entityId}/sales/${version}${location.search}`} />;
}
